<script lang="ts">
  import { defineComponent } from 'vue'
  export default defineComponent({
    name: 'BasicLoading',
  })
  </script>
<template>
  <div
    v-show="loading"
    class="full-loading"
    :class="absolute && 'is-absolute'"
    :style="{
      backgroundColor: background,
    }"
  >
    <Spin v-bind="$attrs" :tip="tip" :size="size" :spinning="loading" />
  </div>
</template>
<script lang="ts" name="BasicLoading" setup>
  import { type SpinSize } from './typing'
  import { Spin } from 'ant-design-vue'

  withDefaults(
    defineProps<{
      tip?: string
      size?: SpinSize
      absolute?: boolean
      loading?: boolean
      background?: string
    }>(),
    {
      tip: '',
      size: 'large',
      absolute: false,
      loading: false,
    },
  )
</script>
<style lang="less" scoped>
  .full-loading {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1007;
    display: flex;
    width: 100%;
    height: 100%;
    justify-content: center;
    align-items: center;
    background-color: rgba(240, 242, 245, 0.4);

    &.is-absolute {
      position: absolute;
      top: 0;
      left: 0;
      z-index: 1008;
    }
  }
</style>
